import { Paths } from '../../../lib/constants/path'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { Route } from '../../../lib/types/routes'
import PromoCodeCreatePage from './promo-code-create'
import PromoCodeListPage from './promo-code-list'
import PromoCodeUpdatePage from './promo-code-update'

const promoCodeRoutes: Route[] = [
  {
    path: Paths.PROMO_CODE_LIST_PAGE,
    element: <PromoCodeListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PROMO_CODE_CREATE_PAGE,
    element: <PromoCodeCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.PROMO_CODE_UPDATE_PAGE,
    element: <PromoCodeUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default promoCodeRoutes
